'use client';

import { Fragment } from 'react';
import { IconRings } from 'app/components/sprites';
import useCopyToClipboardButton from 'app/hooks/useCopyToClipboardButton';
import { CopyToClipboardNotification } from 'app/components/common/CopyToClipboardNotification';

export default function CopyToClipboardButton() {
  const { isOpen, setIsOpen, onCopyToClipboardButtonClick } =
    useCopyToClipboardButton();

  return (
    <Fragment>
      <button
        onClick={onCopyToClipboardButtonClick}
        className="w-10 h-10 rounded bg-brown-dark flex flex-col justify-center items-center"
      >
        <IconRings className="w-4 h-4 fill-none stroke-sand-light" />
      </button>
      <CopyToClipboardNotification
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      />
    </Fragment>
  );
}
